<template>
  <aside class="sidebar">
    <div class="logo-grid">
      <span v-for="n in 9" :key="n"></span>
    </div>

    <div class="menu">
      <button v-for="item in items" :key="item" class="icon-btn">
        {{ item  }} --
      </button>
    </div>

    <div class="bottom-icons">
      <button class="icon-btn">⚙</button>
      <button class="icon-btn">⤴</button>
      <div class="avatar">👨🏽</div>
      <button class="icon-btn">☾</button>
    </div>
  </aside>
</template>

<script setup>
const items = ["☰", "⌗", "◫", "◻"];
</script>

<style scoped>
.sidebar {
  width: 72px;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
}

.logo-grid {
  display: grid;
  grid-template-columns: repeat(3, 8px);
  gap: 4px;
  margin-top: 6px;
}

.logo-grid span {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: #2f80ed;
}

.menu,
.bottom-icons {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}

.icon-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  font-size: 18px;
}

.icon-btn:hover {
  background: #f3f4f6;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f3f4f6;
  display: grid;
  place-items: center;
  font-size: 18px;
}
</style>